import { useAccountSetting } from "@/settings/account-settings-context";
import type { CardRowOrder } from "./cards";

/**
 * Выбор порядка строк карточки §9 (1.23). С §127 живёт в настройках аккаунта;
 * чтение из браузера осталось для переезда прежней записи. Чтение обёрнуто в
 * `try/catch`: приватное окно или запрет хранилища бросают исключение.
 */

export const CARD_ROW_ORDER_STORAGE_KEY = "screener.cards.rowOrder";

const DEFAULT_ROW_ORDER: CardRowOrder = "book";

function isCardRowOrder(value: string | null): value is CardRowOrder {
  return value === "book" || value === "volume";
}

/**
 * Читает выбор из хранилища. Хранилище — параметр, а не `window.localStorage`
 * напрямую, чтобы тест мог подставить своё, включая бросающее исключение.
 * Значение, отличное от `"book"`/`"volume"`, считается отсутствующим.
 */
export function readCardRowOrder(storage: Storage): CardRowOrder {
  try {
    const value = storage.getItem(CARD_ROW_ORDER_STORAGE_KEY);
    return isCardRowOrder(value) ? value : DEFAULT_ROW_ORDER;
  } catch {
    return DEFAULT_ROW_ORDER;
  }
}

/**
 * Порядок строк карточек §9 (1.23) берётся из настроек аккаунта (§127);
 * подпись прежняя. Чтение из браузера (`readCardRowOrder`) осталось для
 * переезда прежней записи (design.md stage9-account-settings, Д5).
 */
export function useCardRowOrder(): [CardRowOrder, (next: CardRowOrder) => void] {
  const [store, rowOrder] = useAccountSetting("rowOrder");
  return [rowOrder, store.setRowOrder];
}
